import React from 'react';

export interface TextFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  type?: 'text' | 'email' | 'tel' | 'password' | 'date';
  placeholder?: string;
  required?: boolean;
  id?: string;
  disabled?: boolean;
}

/**
 * Reusable text input field component
 */
export const TextField: React.FC<TextFieldProps> = ({
  label,
  value,
  onChange,
  error,
  type = 'text',
  placeholder,
  required = false,
  id,
  disabled = false,
}) => {
  const fieldId = id || `text-field-${label.toLowerCase().replace(/\s+/g, '-')}`;
  const errorId = `${fieldId}-error`;

  return (
    <div style={{ marginBottom: '15px' }}>
      <label 
        htmlFor={fieldId} 
        style={{ 
          display: 'block', 
          marginBottom: '5px', 
          fontWeight: required ? 'bold' : 'normal' 
        }}
      >
        {label}
        {required && <span style={{ color: 'red', marginLeft: '4px' }} aria-label="required">*</span>}
      </label>
      <input
        id={fieldId}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        aria-invalid={error ? 'true' : 'false'}
        aria-describedby={error ? errorId : undefined}
        style={{
          width: '100%',
          padding: '8px',
          fontSize: '14px',
          border: error ? '1px solid #dc3545' : '1px solid #ccc',
          borderRadius: '4px',
          boxSizing: 'border-box',
        }}
      />
      {error && (
        <div
          id={errorId}
          role="alert"
          style={{
            color: '#dc3545',
            fontSize: '12px',
            marginTop: '4px',
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
};

